import { DecimalPipe } from '@angular/common';
import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ScreenService } from '@services/screen.service';
import {DxPieChartComponent, DxTemplateDirective} from "devextreme-angular";
import {DxiSeriesComponent, DxoLabelComponent, DxoTooltipComponent} from "devextreme-angular/ui/nested";

export type ChartDataPoint = { argument: string; value: number;}

@Component({
    selector: 'app-next-view-doughnut-chart',
    imports: [
        DxPieChartComponent,
        DxTemplateDirective,
        DxiSeriesComponent,
        DxoLabelComponent,
        DxoTooltipComponent,
        DecimalPipe,
    ],
    templateUrl: './next-view-doughnut-chart.component.html',
})
export class NextViewDoughnutChartComponent implements OnChanges {
    @Input() item: ChartDataPoint | null = null;

    private screen = inject(ScreenService);

    chartItems: ChartDataPoint[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.item) {
            this.chartItems = this.item? [{argument: 'Score', value: this.item.value}]: [];
        }
    }

    customizeTooltip = ({ value }: { value: number }) => ({
        text: `${value}%`,
    });

    customizePoint = (pointInfo: { value: number }) => {
        return {
            color: this.getThresholdColor(pointInfo.value),
        };
    }

    get isLarge() {
        return this.screen.sizes['screen-large'] || this.screen.sizes['screen-medium'];
    }

    getCenterText(percent: number | undefined) {
        if (percent === undefined) {
            return '';
        }

        if (percent <= 70) {
            return 'Below Standard';
        } else if (percent <= 85) {
            return 'Almost There';
        } else {
            return 'Good Job!';
        }
    }

    private getThresholdColor(percent: number): string {
        const getColor = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim();

        if (percent <= 70) {
            return getColor('--bs-danger');
        }

        if (percent <= 85) {
            return getColor('--bs-warning');
        }

        return getColor('--bs-success');
    }
}
